import { produce } from 'immer';
import { SET_VERIFY_ACCOUNT_DONE, SET_VERIFY_ACCOUNT_ERROR_FROM_INBOUND } from '../actions/verifyAccountActions';
const initialState = {};
const verifyAccountReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_VERIFY_ACCOUNT_ERROR_FROM_INBOUND: {
                draft.verifyResult = { type: 'error', error: action.payload.error };
                break;
            }
            case SET_VERIFY_ACCOUNT_DONE: {
                draft.verifyResult = { type: 'success' };
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default verifyAccountReducer;
